import { getRequest } from "shared/utils/fetch-api";

export const fetchClearAllCookies = async () => {
    try {
        const response = await getRequest({}, 'dms-hr', 'getLogout', 'POST');
        const data = await response.json();
        if (data.Errors.length === 0) {
            return true
        } else {
            return false
        }
    } catch (error) {
        return false
    }
};